import { createListenerMiddleware } from '@reduxjs/toolkit';
import { RootState } from 'store';
import { eventsReportApi } from 'store/apis/eventsReport';

import { insightsReportsWizardActions } from './insightsReportsWizard.actions';
import { selectInitialReportSource } from './insightsReportsWizard.selectors';

export const insightsReportsWizardListener = createListenerMiddleware();

insightsReportsWizardListener.startListening({
  matcher: eventsReportApi.endpoints.getEventsReportSources.matchFulfilled,
  effect: ({ payload: { data } }, { dispatch, getState }) => {
    const initialReportSource = selectInitialReportSource(getState() as RootState);
    if (!initialReportSource || !data) return;

    const reportSourceDetails = data.find(({ id }) => initialReportSource.id === id);
    if (!reportSourceDetails) return;

    dispatch(insightsReportsWizardActions.reportSources.reportSourceSelected(reportSourceDetails));
  },
});
